import { Badge } from "../ui/badge";

export const EmptyCell = ({ value }: { value?: string }) => {
      return <Badge className={`text-center rounded-full bg-muted text-muted-foreground`}>{value || "-"}</Badge>;
};
